/**
 * Converts a portfolio name to a URL-friendly slug.
 * Example: "My USD Portfolio!" -> "my-usd-portfolio"
 */
export function slugify(name) {
  return (name || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Normalizes API responses that may be a plain array
 * or a .NET-style { "$values": [...] } object.
 */
export function toArray(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.$values)) return data.$values;
  return [];
}
